// Rank movement since the last leaderboard: ▲3 (emerald), ▼2 (rose), – (slate), New (cobalt).
export type Movement = { dir: 'up' | 'down' | 'same' | 'new'; n: number };

/** prevRank undefined = new on the board. */
export function movement(rank: number, prevRank?: number): Movement {
  if (prevRank === undefined || prevRank === null || prevRank <= 0) return { dir: 'new', n: 0 };
  if (prevRank > rank) return { dir: 'up', n: prevRank - rank };
  if (prevRank < rank) return { dir: 'down', n: rank - prevRank };
  return { dir: 'same', n: 0 };
}
const label = (m: Movement) => (m.dir === 'up' ? `Up ${m.n} ${m.n === 1 ? 'place' : 'places'}` : m.dir === 'down' ? `Down ${m.n} ${m.n === 1 ? 'place' : 'places'}` : m.dir === 'same' ? 'No change' : 'New on the board');

export function MovementBadge({ rank, prevRank, className = '' }: { rank: number; prevRank?: number; className?: string }) {
  const m = movement(rank, prevRank);
  return (
    <span className={`rd-move ${className}`} data-dir={m.dir} role="img" aria-label={label(m)}>
      {m.dir === 'up' && <><svg width="9" height="8" viewBox="0 0 10 9" aria-hidden="true"><path d="M5 .8 9.4 8.2H.6Z" fill="currentColor" /></svg>{m.n}</>}
      {m.dir === 'down' && <><svg width="9" height="8" viewBox="0 0 10 9" aria-hidden="true"><path d="M5 8.2.6.8h8.8Z" fill="currentColor" /></svg>{m.n}</>}
      {m.dir === 'same' && <span aria-hidden="true">–</span>}
      {m.dir === 'new' && <span aria-hidden="true" className="font-ui text-[0.72rem] font-bold">New</span>}
    </span>
  );
}
